import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../style.css";
import "../style1.css";
import "./instantreport.css";
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import Keywordbar from "../Rightsidebar/Keywordbar";
import { useNavigate } from "react-router-dom";
import 'chartjs-adapter-moment';
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import NewLoader from "../NewLoader";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import LinkIcon from '@mui/icons-material/Link';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import Siteanalysis from "../siteaudit/Siteanalysis";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import { Commonfun, timezonechange, timezoneval } from "../Commonfun";
import { toast } from "react-toastify";
import Schemaanalysis from "../Schemaanalysis";
import Codeauditlist from "../codeaudit/Codeauditlist";
import CodeauditDetail from "../codeaudit/CodeauditDetail";
import ContentauditDetail from "../Contentaudit/ContentauditDetail";
import AccessbilityaxeDetails from "../AccessbilityAxe/Detail";
import Loader from "../CommonLoader";
import AccessbilityaxescanDetails from "../AccessbilityAxe/Detailaxe";
import Schemadetail from "../schema/Schemadetail";
import ExternalLinkListData from "../linkchecker/ExternalLinkLists";
import moment from "moment";
import AccessbilityScoreDetails from "../Performance/Detail";
import AccessbilityReportDetails from "../AccessbilityReport/Detail";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import trueimages from "./../Asset/true-images.png";
import failimages from "./../Asset/fail-images.png";
import Typography from "@mui/material/Typography";
const AiReadinessInstantDetail = ({ instantReport, jobDate }) => {
    const data = instantReport?.result || {};
    const linkUrl = data?.link_url || "";

    const formatKey = (key) => {
        return key
            ?.replace(/--,|[^a-zA-Z0-9_]/g, "")
            ?.replace(/_/g, " ")
            ?.replace(/\b\w/g, (char) => char.toUpperCase())
            ?.replace(/\bTxt\b/g, "TXT")
            ?.replace(/\bLlM\b/g, "LLM")
            ?.replace(/\bLlm\b/g, "LLM")
            ?.replace(/\bAi\b/g, "AI")
            ?.replace(/\bJson\b/g, "JSON")
            ?.replace(/\bLd\b/g, "LD")
            ?.replace(/\bHtml\b/g, "HTML")
            ?.replace(/\bEeAt\b/g, "EEAT")
            ?.replace(/\bEeat\b/g, "EEAT");
    };

    const getItem = (sectionData, expectedKey) => {
        if (!sectionData || typeof sectionData !== "object") return null;

        const matchedEntry = Object.entries(sectionData).find(([actualKey]) => {
            const cleanedActualKey = actualKey?.replace(/--,|[^a-zA-Z0-9_]/g, "");
            return cleanedActualKey === expectedKey;
        });

        return matchedEntry ? matchedEntry[1] : null;
    };

    const renderRow = (keyName, item) => {
        if (!item || typeof item !== "object") return null;

        return (
            <Accordion expanded={true} style={{ marginBottom: "5px" }} key={keyName}>
                <AccordionSummary>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            gap: "15px",
                        }}
                    >
                        <div
                            style={{
                                width: "35%",
                                minWidth: "250px",
                                fontWeight: 400,
                                color: "#000",
                                wordBreak: "break-word",
                            }}
                        >
                            {formatKey(keyName)}
                        </div>

                        <div
                            style={{
                                flex: 1,
                                color: "#666",
                                wordBreak: "break-word",
                            }}
                        >
                            {item?.message || "N/A"}
                        </div>

                        <div
                            style={{
                                width: "50px",
                                textAlign: "center",
                                flexShrink: 0,
                            }}
                        >
                            <img
                                src={item?.result === true ? trueimages : failimages}
                                style={{ width: "20px" }}
                                alt="status"
                            />
                        </div>
                    </div>
                </AccordionSummary>
            </Accordion>
        );
    };

    const renderSection = (sectionTitle, sectionData, itemKeys) => {
        if (!sectionData || typeof sectionData !== "object") return null;

        return (
            <div key={sectionTitle}>
                <h2 className="report_sub_title" style={{ marginTop: "20px" }}>
                    {sectionTitle}
                </h2>

                {itemKeys.map((itemKey) => renderRow(itemKey, getItem(sectionData, itemKey)))}
            </div>
        );
    };

    return (
        <>
            <Container maxWidth={false} className="dashboard-container" style={{ padding: "0px" }}>
                <Box className="dashboard-box-time">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={6}>
                            <div className="time_zone">
                                <span>
                                    <a target="_blank" href={linkUrl} rel="noreferrer">
                                        <span style={{ display: "inline-block" }} className="spanlink">
                                            {linkUrl}
                                        </span>
                                    </a>
                                </span>
                                <br />
                                <span className="timezone-date">{timezonechange(jobDate)}</span>
                                <br />
                                <span className="timezone-val">{timezoneval()}</span>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Box sx={{ mt: 3, p: 2, bgcolor: "#fff", borderRadius: "8px" }} className="grid_table_shodow">
                {renderSection("Crawlability", data.crawlability, [
                    "llm_txt_exists",
                    "ai_bots_allowed",
                    "robots_txt_exists",
                    "sitemap_xml_exists",
                    "sitemap_listed_in_robots",
                ])}

                {renderSection("Semantic Structure", data.semantic_structure, [
                    "main_tag_exists",
                    "footer_tag_exists",
                    "header_tag_exists",
                    "single_h1_present",
                    "valid_heading_order",
                ])}

                {renderSection("Content Clarity", data.content_clarity, [
                    "word_count_300",
                    "content_chunking",
                    "paragraph_length",
                    "title_tag_exists",
                    "ai_extractability",
                    "meta_description_exists",
                    "content_uniqueness",
                    "answer_completeness",
                    "engagement_readiness",
                    "above_the_fold_clarity",
                    "direct_answer_presence",
                    "search_intent_alignment",
                    "content_format_diversity",
                ])}

                {renderSection("Structured Data", data.structured_data, [
                    "faq_schema",
                    "valid_json_ld",
                    "organization_schema",
                    "schema_markup_present",
                ])}

                {renderSection("Page Rendering", data.page_rendering, [
                    "rendering",
                    "page_speed",
                    "homepage_status_200",
                    "canonical_tag_exists",
                    "html_content_present",
                    "meta_robots_indexable",
                ])}

                {renderSection("Authority & Context", data.authority_context, [
                    "eeat_signals",
                    "internal_linking",
                    "external_references",
                ])}
            </Box>
        </>
    );
};
const InstantReport = () => {

    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
    const navigate = useNavigate();
    const esodata = useSelector((state) => state);
    const ApiToken = esodata.apiauthkey.value;
    const [apiopen, setapiOpen] = useState(false);
    const [successApiopen, setSuccessApiOpen] = useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [successApierrorMsg, setSuccessApierrorMsg] = useState();
    const [domainNameUrl, setDomainNameUrl] = useState({
        domain_name: "",
        domain_url: "",
    });
    const [PageNamesOptions, setPageNamesOptions] = useState([]);
    const [selectedPageOption, setSelectedPageOption] = useState(null);
    const [selectedUrl, setSelectedUrl] = useState("");
    const [selectedPageId, setSelectedPageId] = useState("1");
    const [instantReport, setInstantReport] = useState(null);
    const [reportStatus, setreportStatus] = useState(false);
    const [showDetails, setShowDetails] = useState(true);
    const [loading, setLoading] = useState(false);
    const [modifiedApi, setModifiedApi] = useState(null);
    const [openOnBound, setOpenOnBound] = useState(false);
    const [linkTab, setLinkTab] = useState('internal');
    const [urlError, setUrlError] = useState("");
    const jobDate = moment(new Date()).format("MMMM DD,YYYY HH:mm");

    // Rank Checker fields
    const [keyword, setKeyword] = useState("");
    const [preferredUrl, setPreferredUrl] = useState("");
    const [engineOptions, setEngineOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const deviceOptions = [{ label: "Desktop", value: "desktop" }, { label: "Mobile", value: "mobile" }];
    const mobileTypeOptions = [{ label: "iOS", value: "ios" }, { label: "Android", value: "android" }];

    const [searchEngine, setSearchEngine] = useState({ label: "Google", value: "1" });
    const [country, setCountry] = useState(null);
    const [state, setState] = useState(null);
    const [city, setCity] = useState(null);
    const [device, setDevice] = useState({ label: "Desktop", value: "desktop" });
    const [mobileType, setMobileType] = useState(null);

    const [freesiteaudit, setfreesiteaudit] = useState({ status: false, error: "" });
    const [initialDateval, SetInitialDateval] = useState([]);
    const [faqData, setfaqData] = useState("2");
    const [toggle, setToggle] = useState(false);
    const [checkD, setcheckD] = useState(false);
    const [first, setfirst] = useState({
        name: "",
        path: "",
        closeName: "Close",
        statusDomain: false,
    });
    let detailurl = `${process.env.REACT_APP_DOMAIN}`;
    const getReportFileName = (reportName) => {
        const reportFileNameMap = {
            "Site Analysis": "SiteAnalysis",
            "Schema Analysis": "SchemaAnalysis",
            "Source Code Analysis": "SourceCodeAnalysis",
            "Analysis Summary": "AnalysisSummary",
            "Accessibility Score": "AccessibilityScore",
            "Performance": "Performance",
            "Accessibility Report": "AccessibilityReport",
            "AI Readiness": "AIReadiness",
            "Link Checker": linkTab === "internal" ? "InternalLinkChecker" : "ExternalLinkChecker",
        };

        return reportFileNameMap[reportName] || reportName?.replace(/\s+/g, "");
    };


useEffect(() => {
        freeAudit();
        getPageNames();
        GetuserDatavalue();
        fetchEngines();
        fetchCountries();
        faqdatafun();
    }, [])

    const fetchEngines = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}keywords/search_engine_locale_list/`, { headers: { Authorization: `${ApiToken}` } });
            if (res.data) setEngineOptions(res.data.map(i => ({ label: i.name, value: i.id })));
        } catch (err) { console.log(err); }
    };

    const fetchCountries = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}keywords/get_countries/`, { headers: { Authorization: `${ApiToken}` } });
            if (res.data) setCountryOptions(res.data.map(i => ({ label: i.name, value: i.id })));
        } catch (err) { console.log(err); }
    };

    const handleCountryChange = async (selected) => {
        setCountry(selected); setState(null); setCity(null); setStateOptions([]); setCityOptions([]);
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}keywords/get_state_by_country/?country_id=${selected.value}`, { headers: { Authorization: `${ApiToken}` } });
            if (res.data?.states) setStateOptions(res.data.states.map(i => ({ label: i.state_name, value: i.id })));
        } catch (err) { console.log(err); }
    };

    const handleStateChange = async (selected) => {
        setState(selected); setCity(null); setCityOptions([]);
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}keywords/get_cities_by_state/?state_id=${selected.value}`, { headers: { Authorization: `${ApiToken}` } });
            if (res.data?.cities) setCityOptions(res.data.cities.map(i => ({ label: i.city_name, value: i.id })));
        } catch (err) { console.log(err); }
    };

    const faqdatafun = async (menubutval = "") => {
        var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=82`

        try {
            const doaminsectiondatavalue = await axios.get(
                datavar,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (doaminsectiondatavalue?.data) {

                SetInitialDateval(doaminsectiondatavalue?.data?.faqs)
            }
        } catch (err) { }
    }

    const GetuserDatavalue = async () => {
        try {
            const datavalue = await axios
                .get(`${process.env.REACT_APP_API_URL}accounts/get_user_details/`, {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                })
                .catch((error) => {
                    if (
                        error?.response?.status == 599 ||
                        error?.response?.status == 500 ||
                        error?.response?.status == 400 ||
                        error?.response?.status == 404
                    ) {
                        navigate("/errorpages");
                    } else if (error?.code == "ERR_NETWORK") {
                        navigate("/errorpages");
                    }
                });

            if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
                setDomainNameUrl({
                    ...domainNameUrl,
                    domain_name: datavalue?.data?.dor_domain_name,
                    domain_url: datavalue?.data?.dor_domain_url,
                });
            }

            if (datavalue?.data) {
                if (datavalue?.data?.is_location_required === true) {
                    setfirst({
                        ...first,
                        name: "Verify Now",
                        path: "/Userdata",
                        statusDomain: true,
                    });
                    return;
                }
                if (datavalue?.data?.is_domain_required === true) {
                    setfirst({
                        ...first,
                        name: "Verify Now",
                        path: "/Impadddomain",
                        statusDomain: true,
                    });
                    return;
                }
                if (datavalue?.data?.is_domain_ownership_required === true) {
                    setfirst({
                        ...first,
                        name: "Verify Now",
                        path: "/Domainownership",
                        statusDomain: true,
                    });
                    return;
                }
            }
        } catch (err) {
            console.log(err);
        }
    };


    const handleToggle = () => {
        if (faqData != 1) {
            setfaqData(1)
        }
        else {
            setfaqData(2)
        }
        setToggle((pre) => !pre);
    };

    const freeAudit = async () => {
        const check = await Utils("custom_report", ApiToken);
        setfreesiteaudit(true);
    }

    const getPageNames = async () => {
        var datavar = `${process.env.REACT_APP_API_URL}instant_report/instant_report_types/`
        try {
            const allPageNames = await axios.get(
                datavar,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (allPageNames?.data) {
                console.log('allPageNames?.data', allPageNames?.data);

                let pageOptions = [];
                allPageNames?.data.report_types.map((option) => {
                    pageOptions.push({ value: option, label: option });
                });
                if (!pageOptions.some(opt => opt.value === 'AI Readiness')) {
                    pageOptions.push({ value: 'AI Readiness', label: 'AI Readiness' });
                }
                setPageNamesOptions(pageOptions);
            }

        } catch (err) {
            console.log('error in get pagenames' + err);
        }
    }

const onChangePageSelect = (selected) => {
        setreportStatus(false);
        setKeyword(""); setPreferredUrl(""); setSearchEngine({ label: "Google", value: "1" });
        setCountry(null); setState(null); setCity(null);
        setDevice({ label: "Desktop", value: "desktop" }); setMobileType(null);
        if (selected.value === "Site Analysis") { setSelectedPageId("1"); }
    }
        
    

    const onSubmitPageName = async (modifiedApi, detailPageId) => {
        const urlPattern = /^https?:\/\/.+/i;
        if (!urlPattern.test(selectedUrl.trim())) {
            setUrlError("Please enter a valid URL starting with https:// or http://");
            return;
        }
        setUrlError("");
        setLoading(true);
        setInstantReport(null);
        //submit function here
        var datavar = `${process.env.REACT_APP_API_URL}instant_report/instant_report_view/?user_domain_id=${esodata.domaindata.value.header_selected}&report_name=${selectedPageOption.value}&url=${selectedUrl}`
       if (selectedPageOption.value === 'Rank Checker') {
            const finalDevice = device?.value === 'mobile' ? (mobileType?.value || 'mobile') : 'desktop';
            datavar = `${datavar}&keyword=${encodeURIComponent(keyword)}&preferred_url=${encodeURIComponent(preferredUrl)}&search_engine=${encodeURIComponent(searchEngine?.value || "")}&country=${encodeURIComponent(country?.value || "")}&state=${encodeURIComponent(state?.value || "")}&city=${encodeURIComponent(city?.value || "")}&device=${encodeURIComponent(finalDevice)}`;
        }
        if (selectedPageOption.value === 'AI Readiness') {
            datavar = `${datavar}&report_type=detail`;
        }
        if (selectedPageOption.value === 'Accessibility Score') {
            datavar = `${datavar}${modifiedApi ? modifiedApi : '&audit_type=passed'}`;
            setModifiedApi(datavar);
            if (modifiedApi && detailPageId) {
                const urlData = {
                    detail_id: detailPageId,
                    audit_type: datavar.includes('passed') ? "passed" : "failed",
                    url: selectedUrl
                };

                const urlQuery = encodeURIComponent(JSON.stringify(urlData));
                window.open(`${detailurl}accessibility-score-scan-detail?urlData=${urlQuery}`, '_blank')
            }
        }
        if (selectedPageOption.value === 'On Page Crawl') {
            datavar = `${datavar}${modifiedApi ? modifiedApi : '&field_type=all'}`;
            setModifiedApi(datavar);
        }
        if (!detailPageId) {
            try {
                const instantReport = await axios.get(
                    datavar,
                    {
                        headers: {
                            Authorization: `${ApiToken}`,
                        },
                    }
                ).catch((error) => {
                    if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                        setapiOpen(true);
                        setapierrorMsg(error?.response?.data?.error)
                    }
                    else if (error?.response?.status == 598) {
                        setSuccessApiOpen(true);
                        setSuccessApierrorMsg(error?.response?.data?.message)
                    }
                    else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                        navigate('/errorpages')
                    }
                });
                if (instantReport?.data) {
                    setInstantReport(instantReport?.data);
                    setreportStatus(true);
                }

            } catch (err) {
                console.log('error in get pagenames' + err);
            }
        }
        setLoading(false);
    }

    const apihandleClose = () => {
        setapiOpen(false);
    };
    const successApihandleClose = () => {
        setSuccessApiOpen(false);
    };

    const downloadPdfCsv = async (downloadType) => {
        setLoading(true);
        var datavar = `${process.env.REACT_APP_API_URL}instant_report/instant_report_view/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=${downloadType}&timezone=${timezoneval()}&report_name=${selectedPageOption.value}&url=${selectedUrl}`;
       if (selectedPageOption.value === 'Rank Checker') {
            const finalDevice = device?.value === 'mobile' ? (mobileType?.value || 'mobile') : 'desktop';
            datavar = `${datavar}&keyword=${encodeURIComponent(keyword)}&preferred_url=${encodeURIComponent(preferredUrl)}&search_engine=${encodeURIComponent(searchEngine?.value || "")}&country=${encodeURIComponent(country?.value || "")}&state=${encodeURIComponent(state?.value || "")}&city=${encodeURIComponent(city?.value || "")}&device=${encodeURIComponent(finalDevice)}`;
        }
        if (selectedPageOption.value === 'AI Readiness') {
            datavar = `${datavar}&report_type=detail`;
        }
        if (selectedPageOption.value === 'Accessibility Score') {
            let selectedAudit = modifiedApi.includes('passed') ? "passed" : "failed"
            datavar = `${datavar}&audit_type=${selectedAudit}`
        }
        if (selectedPageOption.value === 'Link Checker') {
            datavar = `${datavar}&external=${linkTab === 'internal' ? true : false}`
        }

        try {
            const response = await fetch(datavar, {
                method: 'GET',
                headers: {
                    'Content-Type': `application/${downloadType}`,
                    Authorization: `${ApiToken}`,
                },
            });

            if (response.ok) {

                const blob = await response.blob();


                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                const reportFileName = getReportFileName(selectedPageOption.value);

                var filedata = await Commonfun(
                    reportFileName,
                    downloadType,
                    ApiToken,
                    esodata.domaindata.value.header_selected
                );
                link.download = filedata;
                link.click();


                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error(`Error during ${downloadType} download:`, error);
        }
        setLoading(false);
    }


    return (
        <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
            {loading === true ? <Loader /> : null}

            <Helmet>
                <meta charSet="utf-8" />
                <title>Instant Report</title>
            </Helmet>

            <Container maxWidth={false} className="dashboard-container">
                <Box className="dashboard-box">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={4}>
                            <div>
                                <h1 className="dashboard_header">
                                    Instant Reports
                                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                                </h1>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <div className="top_breadcrumb_menu">
                                <div className="exportpdf_outer">
                                    <div className="breadcrumb-wrapper">
                                        <CommonBreadCrumb breadcrumbValue={[
                                            { title: 'Report' },
                                            { title: 'Instant Report', activeColor: true }
                                        ]} />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Container maxWidth={false} className="dashboard-container">
                <Box className="dashboard-box-tab">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={12}>
                            <div className="frm_container">
                                {showDetails &&
                                    <div className="campaigns-addedit-row">
                                        <div className="filter-item keyword-col1-fields">
                                            <span className="listdropdown_titl">Report Type</span>
                                            <Select
                                                classNamePrefix="custom-reporttype-dropdown"
                                                id="section-dropdown"
                                                options={PageNamesOptions}
                                                placeholder="Select Report Type"
                                                value={selectedPageOption}
                                                onChange={(selected) => {
                                                    setSelectedPageOption(selected)
                                                    onChangePageSelect(selected);
                                                }}
                                                styles={customDropdownStyles()}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                        <div className="keyword-col2-fields">
                                            <label className="listdropdown_titl">Enter URL</label>
                                            <input
                                                type="text"
                                                className="instant-report-input"
                                                placeholder="Enter URL"
                                                value={selectedUrl}
                                                onChange={(e) => {
                                                    setSelectedUrl(e.target.value);
                                                    setUrlError("");
                                                }}
                                            />
                                            {urlError && <span style={{ color: "red", fontSize: "12px" }}>{urlError}</span>}
                                        </div>
                                    </div>
                                }
                                {showDetails && selectedPageOption?.value === 'Rank Checker' &&
                                    <div className="campaigns-addedit-row">
                                        <div className="filter-item keyword-col1-fields">
                                            <label className="listdropdown_titl">Keyword</label>
                                            <input
                                                type="text"
                                                className="instant-report-input"
                                                placeholder="Enter Keyword"
                                                value={keyword}
                                                onChange={(e) => setKeyword(e.target.value)}
                                            />
                                        </div>
                                        <div className="keyword-col2-fields">
                                            <label className="listdropdown_titl">Preferred URL</label>
                                            <input
                                                type="text"
                                                className="instant-report-input"
                                                placeholder="Enter Preferred URL"
                                                value={preferredUrl}
                                                onChange={(e) => setPreferredUrl(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                }
                             
                                {showDetails && selectedPageOption?.value === 'Rank Checker' &&
                                    <div className="campaigns-addedit-row">
                                        <div className="filter-item keyword-col1-fields">
                                            <label className="listdropdown_titl">Search Engine</label>
                                           <div style={{ display: 'flex', gap: '20px', height: '38px', alignItems: 'center' }}>
                                                {engineOptions.map((e) => (
                                                    <label key={e.value} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px' }}>
                                                        <input type="radio" name="engine_choice" checked={searchEngine?.value === e.value} onChange={() => setSearchEngine(e)} style={{ marginRight: '8px', accentColor: '#ff601f' }} /> {e.label}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="keyword-col2-fields">
                                            <label className="listdropdown_titl">Country</label>
                                            <Select options={countryOptions} value={country} onChange={handleCountryChange} styles={customDropdownStyles()} menuPortalTarget={document.body} />
                                        </div>
                                    </div>
                                }
                                {showDetails && selectedPageOption?.value === 'Rank Checker' &&
                                    <div className="campaigns-addedit-row">
                                        <div className="filter-item keyword-col1-fields">
                                            <label className="listdropdown_titl">State</label>
                                            <Select options={stateOptions} value={state} onChange={handleStateChange} styles={customDropdownStyles()} isDisabled={!country} menuPortalTarget={document.body} />
                                        </div>
                                        <div className="keyword-col2-fields">
                                            <label className="listdropdown_titl">City</label>
                                            <Select options={cityOptions} value={city} onChange={(s) => setCity(s)} styles={customDropdownStyles()} isDisabled={!state} menuPortalTarget={document.body} />
                                        </div>
                                    </div>
                                }
                                {showDetails && selectedPageOption?.value === 'Rank Checker' &&
                                    <div className="campaigns-addedit-row">
                                        <div className="filter-item keyword-col1-fields">
                                            <label className="listdropdown_titl">Device</label>
                                            <Select options={deviceOptions} value={device} onChange={(s) => { setDevice(s); setMobileType(null); }} styles={customDropdownStyles()} menuPortalTarget={document.body} />
                                        </div>
                                        <div className="keyword-col2-fields">
                                            {device?.value === 'mobile' && (
                                                <>
                                                    <label className="listdropdown_titl">Mobile OS Type</label>
                                                    <Select options={mobileTypeOptions} value={mobileType} onChange={(s) => setMobileType(s)} styles={customDropdownStyles()} placeholder="iOS or Android?" menuPortalTarget={document.body} />
                                                </>
                                            )}
                                        </div>
                                    </div>
                                }

                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div>
                                        <button
                                            variant="contained"
                                            className="btn_dashboard"
                                            onClick={() => setShowDetails(!showDetails)}
                                        >
                                            {showDetails ? 'Hide' : 'Show'}
                                        </button>
                                        {showDetails &&
                                            <button
                                                variant="contained"
                                                className="btn_dashboard"
                                                onClick={() => onSubmitPageName()}
                                                disabled={!selectedPageOption || !selectedUrl || (selectedPageOption?.value === 'Rank Checker' && (!keyword || !preferredUrl || !searchEngine || !country || (device?.value === 'mobile' && !mobileType)))}
                                            >
                                                Generate Report
                                            </button>
                                        }
                                    </div>
                                    {showDetails &&
                                        <div>
                                            <button
                                                variant="contained"
                                                className="btn_dashboard"
                                                onClick={() => downloadPdfCsv('pdf')}
                                                disabled={!reportStatus}
                                            >
                                                PDF
                                            </button>
                                            {/* <button
                                                variant="contained"
                                                className="btn_dashboard"
                                                onClick={() => downloadPdfCsv('csv')}
                                                disabled={!reportStatus}
                                            >
                                                CSV
                                            </button> */}
                                        </div>
                                    }
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            {reportStatus &&
                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box-tab">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={12}>
                                {selectedPageOption &&
                                    <>
                                        {selectedPageOption?.value === "Site Analysis" &&
                                            <Siteanalysis
                                                reportStatus={reportStatus}
                                                pageId={selectedPageId}
                                                instantReport={instantReport} />
                                        }
                                        {selectedPageOption?.value === "Schema Analysis" &&
                                            <Schemadetail
                                                reportStatus={reportStatus}
                                                instantReport={instantReport}
                                                instantUrl={selectedUrl} />
                                        }
                                        {selectedPageOption?.value === "Source Code Analysis" &&
                                            <CodeauditDetail
                                                reportStatus={reportStatus}
                                                instantReport={instantReport} />
                                        }
                                        {selectedPageOption?.value === "Analysis Summary" &&
                                            <ContentauditDetail
                                                reportStatus={reportStatus}
                                                instantReport={instantReport} />
                                        }
                                        {selectedPageOption?.value === "Accessibility Score" &&
                                            <AccessbilityaxeDetails
                                                reportStatus={reportStatus}
                                                instantReport={instantReport}
                                                onSubmitPageName={onSubmitPageName} />
                                        }
                                        {selectedPageOption?.value === "Performance" &&
                                            <AccessbilityScoreDetails
                                                reportStatus={reportStatus}
                                                instantReport={instantReport} />
                                        }
                                        {selectedPageOption?.value === "Accessibility Report" &&
                                            <AccessbilityReportDetails
                                                reportStatus={reportStatus}
                                                instantReport={instantReport} />
                                        }
                                        {selectedPageOption?.value === "AI Readiness" &&
                                            <AiReadinessInstantDetail
                                                reportStatus={reportStatus}
                                                instantReport={instantReport}
                                                jobDate={instantReport?.result?.job_date || jobDate} />
                                        }
                                       {selectedPageOption?.value === "Rank Checker" &&
    <>
        <Container maxWidth={false} className="dashboard-container">
            <Box className="dashboard-box-time">
                <Grid container className="dashboard-grid">
                    <Grid item xs={12} md={6}>
                        <div className="time_zone">
                            <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                            <span className="timezone-val">{timezoneval()}</span>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        </Container>
        <div className="color-checker-container">
            <h2 className="report_sub_title">Search Parameters</h2>
            <table className="table">
                <col style={{ width: "40%" }} />
                <col style={{ width: "60%" }} />
                <tbody>
                    <tr>
                        <td className="table-label" style={{ fontWeight: 800 }}>Keyword: </td>
                        <td>{instantReport?.result?.keyword || '-'}</td>
                    </tr>
                    <tr>
                        <td className="table-label" style={{ fontWeight: 800 }}>Preferred URL: </td>
                        <td>
                            <a href={instantReport?.result?.preferred_url} target="_blank" rel="noopener noreferrer" style={{ color: '#044792' }}>
                                {instantReport?.result?.preferred_url || '-'}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td className="table-label" style={{ fontWeight: 800 }}>Search Engine: </td>
                        <td>{instantReport?.result?.search_engine || '-'}</td>
                    </tr>
                    <tr>
                        <td className="table-label" style={{ fontWeight: 800 }}>Country: </td>
                        <td>{instantReport?.result?.country || '-'}</td>
                    </tr>
                    <tr>
                        <td className="table-label" style={{ fontWeight: 800 }}>Device: </td>
                        <td>{instantReport?.result?.device || '-'}</td>
                    </tr>
                </tbody>
            </table>

            <h2 className="report_sub_title" style={{ marginTop: '20px' }}>Rank Results</h2>
            <table className="table">
                <col style={{ width: "40%" }} />
                <col style={{ width: "60%" }} />
                <tbody>
                    <tr>
                        <td className="table-label" style={{ fontWeight: 800 }}>Position: </td>
                        <td>{instantReport?.result?.position || 'N/R'}</td>
                    </tr>
                    <tr>
                        <td className="table-label" style={{ fontWeight: 800 }}>Found URL: </td>
                        <td>
                            {instantReport?.result?.found_url !== '-' ? (
                                <a href={instantReport?.result?.found_url} target="_blank" rel="noopener noreferrer" style={{ color: '#044792' }}>
                                    {instantReport?.result?.found_url}
                                </a>
                            ) : '-'}
                        </td>
                    </tr>
                    <tr>
                        <td className="table-label" style={{ fontWeight: 800 }}>Total Results Fetched: </td>
                        <td>{instantReport?.result?.total_results || '0'}</td>
                    </tr>
                    <tr>
                        <td className="table-label" style={{ fontWeight: 800 }}>Search Volume: </td>
                        <td>{instantReport?.result?.search_volume_val || '-'}</td>
                    </tr>
                </tbody>
            </table>

          </div>
    </>
}
                                        {selectedPageOption?.value === "Link Checker" &&
                                            <>
                                                <div className="trendy-tabs-wrapper">
                                                    <div className="trendy-tab-container">
                                                        <button type="button"
                                                            className={`trendy-tab ${linkTab === 'internal' ? 'active' : ''}`}
                                                            onClick={() => setLinkTab('internal')}>
                                                            Internal Link Checker</button>
                                                        <button type="button"
                                                            className={`trendy-tab ${linkTab !== 'internal' ? 'active' : ''}`}
                                                            onClick={() => setLinkTab('external')}>
                                                            External Link Checker</button>
                                                    </div>
                                                </div>
                                                <Container maxWidth={false} className="dashboard-container">
                                                    <Box className="dashboard-box-time">
                                                        <Grid container className="dashboard-grid">
                                                            <Grid item xs={12} md={6}>
                                                                <div className="time_zone">
                                                                    <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                                                                    <span className="timezone-val">{timezoneval()}</span>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Container>
                                                {linkTab === 'internal' ?
                                                    <div className="color-checker-container">
                                                        <table className="table">
                                                            <col style={{ width: "50%" }} />
                                                            <col style={{ width: "50%" }} />
                                                            <tbody>
                                                                <tr>
                                                                    <td className="table-label" style={{ fontWeight: 800 }}>URL: </td>
                                                                    <td>{instantReport.url || '-'}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="table-label" style={{ fontWeight: 800 }}>Status Code: </td>
                                                                    <td>{instantReport.status_code || '-'}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="table-label" style={{ fontWeight: 800 }}>Valid: </td>
                                                                    <td>{instantReport.valid ? <CheckCircleIcon style={{ color: 'green' }} /> : <CancelIcon style={{ color: 'red' }} />}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="table-label" style={{ fontWeight: 800 }}>OutBound: </td>
                                                                    <td>
                                                                        <div className="drop_down_button" >
                                                                            <button
                                                                                title="Run Report"
                                                                                className="btn_dashboard"
                                                                                onClick={() => setOpenOnBound(true)}
                                                                            >
                                                                                OutBounds
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div> :
                                                    <ExternalLinkListData
                                                        reportStatus={reportStatus}
                                                        instantReport={instantReport} />
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            }

            <Container maxWidth={false} className="footer-container">
                <Box className="footer-box">
                    <Grid container className="footer-grid">
                        <Grid item xs={12} md={6}>
                            <div className="footer-left">
                                <p className="footer-text">
                                    All Rights Reserved Copyright © 2026 |
                                    <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                                </p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div className="footer-right">
                                <p>{/* Add content if needed */}</p>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            {toggle && <Keywordbar close={() => setToggle(false)} setToggle={setToggle} initialDateval={initialDateval} />}

            <CommonAlert />

            <Dialog
                open={checkD}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="domain-verify-alert"
            >
                <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "15px",
                                lineHeight: "1px",
                                width: "max-content",
                            }}
                        >
                            <p>{`Please verify your domain ${domainNameUrl.domain_name} to access these features`}</p>
                            <a href={domainNameUrl.domain_url}>
                                {domainNameUrl.domain_url}
                            </a>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialog-action-button">
                    <Button
                        onClick={() => {
                            navigate(first.path);
                        }}
                    >
                        {first.name}
                    </Button>
                    <Button onClick={() => setcheckD(false)}>{first.closeName}</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openOnBound}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="domain-verify-alert"
            >
                <DialogTitle className="keyword-dialog-header">OnBound URLs</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div style={{ maxHeight: '10rem' }}>
                            {instantReport?.outbound_links &&
                                <div>
                                    {instantReport?.outbound_links?.map(obLinks => {
                                        let baseUrl = obLinks.url.split("/").slice(0, 4).join("/");
                                        let remaining = obLinks.url.split("/").slice(4).join("/");
                                        return <div className="prefered_url_external02">
                                            <a className="table_links" target="_blank" href={obLinks.url} style={{ display: 'flex', flexDirection: 'column', marginTop: '1rem' }} >
                                                <span className="spanlink" style={{ color: "#044792" }} >
                                                    <LinkIcon /> {baseUrl}
                                                </span>
                                                <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }}>{remaining}</span>
                                            </a>
                                        </div>
                                    })}
                                </div>
                            }
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialog-action-button">
                    <Button onClick={() => setOpenOnBound(false)}>Close</Button>
                </DialogActions>
            </Dialog>

            <CommonErrorAlert
                data={{
                    apiopen: apiopen,
                    apiErrorMsg: apierrorMsg,
                    isIconStyled: true
                }}
                closeAlert={apihandleClose} />
            <CommonErrorAlert
                data={{
                    apiopen: successApiopen,
                    apiErrorMsg: successApierrorMsg,
                    isIconStyled: false
                }}
                closeAlert={successApihandleClose} />
        </div>
    );
};

export default InstantReport;
